import { Map } from "ol";
import Geometry from "ol/geom/Geometry";
import VectorLayer from "ol/layer/Vector";
import { Cluster } from "ol/source";
import VectorSource from "ol/source/Vector";
import { LayerTitle } from "../types/layers";
import { findLayerByTitle } from "./findLayerByTitle";

export function findSourceByTitle(
  map: Map,
  title: LayerTitle,
): VectorSource<Geometry> {
  const layer = findLayerByTitle(map, title) as VectorLayer;
  const s = layer?.getSource();
  const source = s instanceof Cluster ? s.getSource() : s;
  return source;
}
